export const getInstance = state => state.instance;
